import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { WorkflowStepType, WorkflowStepResultType } from '../../models';
import { DecisionModelProcessType, NextFlow, ProductType } from '@core/model/enums';

import { RedirectionService } from '@core/service';
import { DecisionModelService } from '../../services';

import { DECISION_MODEL_STEPS_CONSTANTS } from '../../configs';
import { ROUTES_CONSTANTS } from '@shared/configs';

import { Redirectable } from '@core/model/redirectable';
import { Navigable } from '@core/model/navigable';

export class DecisionModelWorkflow {
  decisionModelProcessType: DecisionModelProcessType;
  productType: ProductType;
  customerId: number;
}

const ALLOWED_FINAL_STEP_FLOWS_CONSTANT = [
  NextFlow.DisbursementAccountSelection,
  NextFlow.DispersionMethodSelection,
  NextFlow.Efecty,
];

@Injectable({ providedIn: 'root' })
export class DecisionModelStep implements WorkflowStepType {
  private router: Router;
  private redirectionService: RedirectionService;
  private readonly decisionModelService: DecisionModelService;

  constructor(private readonly injector: Injector) {
    this.router = this.injector.get(Router);
    this.redirectionService = this.injector.get(RedirectionService);
    this.decisionModelService = this.injector.get(DecisionModelService);
  }

  public execute(): Observable<WorkflowStepResultType> {
    const payload = {
      productType: ProductType.RAPIPLAZO,
      decisionModelProcessType: DecisionModelProcessType.DECISION_MODEL_WORKFLOW,
    } as DecisionModelWorkflow;

    return this.decisionModelService.executeDecisionModel(payload).pipe(
      switchMap((response) => {
        if (ALLOWED_FINAL_STEP_FLOWS_CONSTANT.includes(response?.response?.nextFlow as NextFlow)) {
          return of({ success: true, nextStep: DECISION_MODEL_STEPS_CONSTANTS.FINAL_STEP });
        }

        return this.redirectionService
          .nextFlow(response?.response as Redirectable & Navigable)
          .pipe(map(() => ({ success: true })));
      }),
      catchError(() => {
        this.router.navigate([ROUTES_CONSTANTS.GRAY_ZONE]);
        return of({ success: false });
      })
    );
  }
}
